﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalReports`,
  scopes: ExtHubRequest,
});

api.createEntities([{ name: 'ExecuteSearch' }]);

const ExecuteSearch = (body) => api.endpoints.ExecuteSearch.post(body);

export { ExecuteSearch };
